import { useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import stringHelpers from '../../../utilities/stringHelpers'
import arrayUtilities from '../../../utilities/arrayUtilities'
import { AnalyticsSlider } from '../../shared/analyticsSlider'

const COLOUR = "#F6AD55"

const fmt = m => { const h = m / 60; return (h % 1 === 0 ? h : h.toFixed(1)) + 'h' }

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null
    const value = payload[0].value
    return (
        <div className="analytics-tooltip">
            <p className="analytics-tooltip-title">{ label }</p>
            <span className="analytics-tooltip-value">{ stringHelpers.formatDecimal(value, 0) } vehicle{ value !== 1 ? "s" : "" }</span>
        </div>
    )
}

export const DwellTimeChart = ({ analyticsData }) => {
    const [bucketSize, setBucketSize] = useState(60)

    const allValues = analyticsData.map(d => d.dwellTimeMinutes).filter(v => v !== null).sort((a, b) => a - b)

    if (arrayUtilities.isNullOrEmpty(allValues)) return null

    const rawMax = allValues[Math.floor(allValues.length * 0.98)]
    const dwellMax = Math.ceil(rawMax / bucketSize) * bucketSize

    const aboveMax = analyticsData.filter(d => d.dwellTimeMinutes > dwellMax).length

    const counts = analyticsData
        .filter(d => d.dwellTimeMinutes !== null && d.dwellTimeMinutes <= dwellMax)
        .reduce((acc, d) => {
            const bucket = Math.floor(d.dwellTimeMinutes / bucketSize) * bucketSize
            acc[bucket] = (acc[bucket] ?? 0) + 1
            return acc
        }, {})

    const data = []
    for (let bucket = 0; bucket < dwellMax; bucket += bucketSize) {
        data.push({ name: `${fmt(bucket)}–${fmt(bucket + bucketSize)}`, value: counts[bucket] ?? 0 })
    }
    if (aboveMax > 0) {
        data.push({ name: `>${fmt(dwellMax)}`, value: aboveMax })
    }

    return (
        <div className="analytics-chart-card">
            <div className="analytics-chart-card-header mb-1">
                <p className="analytics-chart-title">Dwell Time Distribution</p>
                <AnalyticsSlider label={ `${fmt(bucketSize)} intervals` } value={ bucketSize } min={ 15 } max={ 120 } step={ 15 } onChange={ setBucketSize } />
            </div>
            <p className="analytics-chart-subtitle mb-3">Vehicles by dwell time (hours)</p>
            <ResponsiveContainer width="100%" height={ 230 }>
                <BarChart data={ data } margin={ { top: 0, right: 8, bottom: 0, left: 0 } }>
                    <XAxis dataKey="name" tick={ { fontSize: 10, fill: "#4a5568" } } axisLine={ false } tickLine={ false } />
                    <YAxis tick={ { fontSize: 11, fill: "#a0aec0" } } axisLine={ false } tickLine={ false } allowDecimals={ false } />
                    <Tooltip content={ <CustomTooltip /> } cursor={ { fill: "#f7fafc" } } />
                    <Bar dataKey="value" radius={ [4, 4, 0, 0] } maxBarSize={ 40 } fill={ COLOUR } />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
